import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { circleXmark } from '@ibk/shared-assets';
import styles from './Chip.module.css';
export function Chip(props) {
    return (_jsxs("button", { type: 'button', className: [
            styles.chip,
            styles[props.size ?? 'small'],
            props.selected ? styles.selected : '',
            props.disabled ? styles.disabled : '',
        ]
            .filter(Boolean)
            .join(' '), onClick: props.onClick, disabled: props.disabled, "data-testid": `button-${props['data-testid']}-chip`, "aria-pressed": props.selected, children: [props.leftImage && (_jsx("img", { className: styles.chipIcon, "data-testid": `img-${props['data-testid']}-chip-left`, src: props.leftImage, alt: 'left' })), _jsx("span", { "data-testid": `span-${props['data-testid']}-chip-text`, className: styles.text, children: props.text }), (props.selected || props.rightImage) && (_jsx("img", { className: styles.chipIcon, "data-testid": `img-${props['data-testid']}-chip-right`, src: props.selected ? circleXmark : props.rightImage, alt: 'right' }))] }));
}
